<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开票服务商：</span>
        </div>
        <el-select v-model="formData.resellerType" placeholder="请选择" size="small" style="width: 280px">
          <el-option
            v-for="item in typeList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div v-if="formData.resellerType === 'BW'" class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">企业私钥：</span>
        </div>
        <el-input v-model="formData.companyPriKey" size="small" style="width: 280px"/>
      </div>
      <div v-if="formData.resellerType === 'BW'" class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">平台公钥：</span>
        </div>
        <el-input v-model="formData.platPubKey" size="small" style="width: 280px"/>
      </div>
      <div v-if="formData.resellerType === 'BW'" class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">企业代码：</span>
        </div>
        <el-input v-model="formData.enterpriseCode" size="small" style="width: 280px"/>
      </div>
      <div v-if="formData.resellerType === 'BW'" class="form-line">
        <div class="textBox">
          <!--          <b class="red">*</b>-->
          <span class="line-text">机器编码：</span>
        </div>
        <el-input v-model="formData.machineNumber" size="small" style="width: 280px"/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">销方ID：</span>
        </div>
        <el-input v-model="formData.resellerId" size="small" disabled style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">销方名称：</span>
        </div>
        <el-input v-model="formData.resellerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">金税盘号：</span>
        </div>
        <el-input v-model="formData.taxDiskNo" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">纳税人识别号：</span>
        </div>
        <el-input v-model="formData.taxPayerIdentificationNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">地址：</span>
        </div>
        <el-input v-model="formData.address" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电话：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开户行：</span>
        </div>
        <el-input v-model="formData.bank" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账号：</span>
        </div>
        <el-input v-model="formData.accountNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">普票限额：</span>
        </div>
        <el-input v-model="formData.invoiceLimit" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">专票限额：</span>
        </div>
        <el-input v-model="formData.sLimit" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">开票人：</span>
        </div>
        <el-input v-model="formData.issuer" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">审核人：</span>
        </div>
        <el-input v-model="formData.reviewer" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款人：</span>
        </div>
        <el-input v-model="formData.payee" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm value="保存" @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/invoice'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'invoice-seller-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '销方管理'
        }],
        mainTitle: '修改销方',
        subheading: '',

        typeList: [
          {code: 'NUONUO', name: '诺诺'},
          {code: 'BW', name: '百旺'},
          {code: 'NN_OPEN_SDK', name: '诺税通saas'},
          {code: 'YL', name: '银联'},
        ],
        formData: {
          resellerType: 'NUONUO',
          platPubKey: '',
          enterpriseCode: '',
          machineNumber: '',
          companyPriKey: '',
          resellerId: '',
          resellerName: '',
          taxDiskNo: '',
          taxPayerIdentificationNumber: '',
          address: '',
          phone: '',
          bank: '',
          accountNumber: '',
          invoiceLimit: '',
          sLimit: '',
          issuer: '',
          reviewer: '',
          payee: '',
        },
      }
    },
    created () {
      this.getResellerConfigurationByCode()
    },
    methods: {
      toManagementPage () {
        this.$router.push({
          name: 'invoice-seller-manage'
        })
      },

      // 查询
      getResellerConfigurationByCode () {
        this.$axios.get(`${api.getResellerConfigurationByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData = res.data.data
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 保存
      confirm () {
        if (!this.formData.resellerId) {
          nError('请输入销方ID')
          return false
        }
        if (!this.formData.resellerName) {
          nError('请输入销方名称')
          return false
        }
        if (!this.formData.taxPayerIdentificationNumber) {
          nError('请输入纳税人识别号')
          return false
        }
        if (!this.formData.address) {
          nError('请输入地址')
          return false
        }
        if (!this.formData.phone) {
          nError('请输入电话')
          return false
        }
        const mobileRegex = /^1[3-9]\d{9}$/;
        const telephoneRegex = /^(0\d{2,3}-)?\d{7,8}(?:(?:#|-|x)\d{1,4})?$/;
        if (this.formData.phone && !mobileRegex.test(this.formData.phone) && !telephoneRegex.test(this.formData.phone)) {
          return nError('电话格式有误，请检查')
        }
        if (!this.formData.bank) {
          nError('请输入开户行')
          return false
        }
        if (!this.formData.accountNumber) {
          nError('请输入账号')
          return false
        }
        if (!this.formData.issuer) {
          nError('请输入开票人')
          return false
        }
        if (!this.formData.reviewer) {
          nError('请输入审核人')
          return false
        }
        if (!this.formData.payee) {
          nError('请输入收款人')
          return false
        }
        this.$axios.post(api.updateResellerConfiguration, this.formData)
          .then(res => {
            nSuccess('修改成功')
            this.toManagementPage()
          })
          .catch(errorHandler('修改失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    },
    watch: {}
  }
</script>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/Invoice/InvoiceSeller/InvoiceSellerModify.vue